import "./css/output.css";
export default function TextValue({ label, value, className, ...props }) {
  const computedClassName = ["output", "text-value", ...className.split(" ")]
    .join(" ")
    .trim();
  return (
    <div className={computedClassName} {...props}>
      {!!label && (
        <>
          <strong>{label}</strong>&nbsp;
        </>
      )}
      <span>{value}</span>
    </div>
  );
}

TextValue.defaultProps = {
  className: "",
};
